export interface BookingInvitee {
  userId?: string
  email?: string
  name?: string
  company?: string
  type: 'internal' | 'external'
  status: 'pending' | 'accepted' | 'declined' | 'maybe'
  avatarVariant?: string
  customAvatarUrl?: string
}

export type BookingStatus = 'SCHEDULED' | 'CANCELLED' | 'COMPLETED'

export interface RoomBookingData {
  objectId?: string
  virtualRoomId: string
  customRoomId: string
  creatorId: string
  creatorName?: string
  roomName?: string
  title: string
  description?: string
  startTime: string // ISO date
  endTime: string // ISO date
  invitees: BookingInvitee[]
  status: BookingStatus
  remindBefore: number // minutes before start to send reminder; 0 = no reminder
  reminderSent: boolean
  companyId: string
}

/** 0 = "No reminder". Mirrored in cloud/utils/bookingReminder.js. */
export const REMIND_BEFORE_OPTIONS = [0, 5, 10, 15, 30] as const
export const MIN_BOOKING_DURATION_MINUTES = 15
export const MAX_BOOKING_DURATION_HOURS = 4
/** Per booking. Mirrored in cloud/utils/guestInviteTokens.js (cloud code can't import types/). */
export const MAX_EXTERNAL_GUESTS = 10
